// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__7jWU6","question":"Question_question__37xRQ","description":"Question_description__3f-po"};